import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Mail } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useScreenInit } from '../../useScreenInit';
export function ForgotPassword() {
  useScreenInit();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/otp');
  };
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-112">
      <header className="px-4 py-4 flex items-center" data-id="element-113">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-114">
          <ChevronLeft className="w-6 h-6" data-id="element-115" />
        </button>
      </header>

      <main className="flex-1 px-6 py-4" data-id="element-116">
        <div className="mb-8" data-id="element-117">
          <h1 className="text-3xl font-heading font-bold text-text-primary mb-2" data-id="element-118">
            Forgot Password
          </h1>
          <p className="text-text-secondary leading-relaxed" data-id="element-119">
            Enter the email address or phone number associated with your
            account. We'll send you a code to reset your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-120">
          <div data-id="element-121">
            <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-122">
              Email or Phone Number
            </label>
            <div className="relative" data-id="element-123">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-text-secondary" data-id="element-124">
                <Mail className="w-5 h-5" data-id="element-125" />
              </div>
              <input type="text" placeholder="Enter your email or phone" className="w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all outline-none text-text-primary" required data-id="element-126" />
            </div>
          </div>

          <Button type="submit" fullWidth size="lg" data-id="element-127">
            Send Reset Code
          </Button>
        </form>
      </main>
    </div>;
}